"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NDSLib", {
  enumerable: true,
  get: function get() {
    return _ndsLib.default;
  }
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _unescape = _interopRequireDefault(require("unescape"));
var _nodeToNdsComponent = _interopRequireDefault(require("./lib/node-to-nds-component"));
var _ndsLib = _interopRequireDefault(require("./lib/nds-lib"));
var HtmlToNds = function HtmlToNds(_ref) {
  var html = _ref.html,
    _ref$decode = _ref.decode,
    decode = _ref$decode === void 0 ? false : _ref$decode,
    _ref$componentDict = _ref.componentDict,
    componentDict = _ref$componentDict === void 0 ? {} : _ref$componentDict,
    _ref$forceWhitelist = _ref.forceWhitelist,
    forceWhitelist = _ref$forceWhitelist === void 0 ? false : _ref$forceWhitelist;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _htmlReactParser.default)(decode ? (0, _unescape.default)(html) : html, {
    replace: (0, _nodeToNdsComponent.default)(componentDict, forceWhitelist)
  }));
};
var _default = HtmlToNds;
exports.default = _default;